import { OPEN_SESSION_TIMEOUT_MODAL, CLOSE_SESSION_TIMEOUT_MODAL } from '../actions/actionTypes';

const initialState = {
  isOpen: false,
};

const sessionTimeoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_SESSION_TIMEOUT_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case CLOSE_SESSION_TIMEOUT_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
};

export default sessionTimeoutReducer;
